import type { ComponentProps } from "react";

import { cn } from "../../lib/utils";
import { useDialogContentContext } from "./DialogContentContext";

export const DialogFooter = ({ className, ...props }: ComponentProps<"div">) => {
  const { divided } = useDialogContentContext();
  return (
    <div
      data-slot="dialog-footer"
      className={cn(
        "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end",
        divided && "px-6 py-4 [&:not(:first-child)]:border-t",
        className
      )}
      {...props}
    />
  );
};
